import "./SendReviewAlertModal.css";

export default function SendReviewAlertModal({ title, message, onClose }) {
    return (
        <div className="alert-overlay">
            <div className="alert-box">
                <h3>{title}</h3>
                <p>{message}</p>
                <button className="alert-btn" onClick={onClose}>OK</button>
            </div>
        </div>
    );
}
